import {
  STICKY_FOOTER_BUTTON_VIEW, STICKY_FOOTER_EMAIL_VIEW,
  STICKY_FOOTER_TOGGLE_TRIGGER,
} from '../actions/types';

import { capitalizeFirstLetter } from 'core/utils/helpers/string';

export const stickyFooterVendorGaActionEvents = {
  [STICKY_FOOTER_BUTTON_VIEW]: () => ({
    category: 'Sticky Footer',
    action: 'View',
    label: 'Button_sticky_footer_desktop_view',
  }),
  [STICKY_FOOTER_EMAIL_VIEW]: ({ isUserOptedOutFromEmail }) => ({
    category: 'Sticky Footer',
    action: 'View',
    label: isUserOptedOutFromEmail ? 'Email_sticky_footer_desktop_view' : 'Email_sticky_footer_desktop_success_view',
  }),
  [STICKY_FOOTER_TOGGLE_TRIGGER]: ({ stickyFooterVendorType, isExpanded }) => {
    const collapseLabel = `${capitalizeFirstLetter(stickyFooterVendorType)}_sticky_footer_desktop_collapse`;
    const expandLabel = `${capitalizeFirstLetter(stickyFooterVendorType)}_sticky_footer_desktop_expand`;

    return {
      category: 'Sticky Footer',
      action: isExpanded ? 'Collapse' : 'Expand',
      label: isExpanded ? collapseLabel : expandLabel,
    };
  },
};

export const stickyFooterVendorClickAndHoverEvents = [
  {
    selector: '.mn_stickyFooterVendor .mn_stickyFooterButton .mn_button',
    click: {
      category: 'Sticky Footer',
      action: 'Click',
    },
    label: 'Button_sticky_footer_desktop_click',
  },
  {
    selector: '.mn_stickyFooterVendor .mn_stickyFooterEmail .mn_button',
    click: {
      category: 'Sticky Footer',
      action: 'Click',
    },
    label: 'Email_sticky_footer_desktop_click',
  },
];
